import 'uni-pages';import '@dcloudio/uni-stat';

import Vue from 'vue'            
import Page from './pages/touristAttraction/detail.vue'
createPage(Page)